export const SURVEY_WFS_LAYER_SOURCE = 'survey-wfs' as const;
export type SurveyLayerSource = typeof SURVEY_WFS_LAYER_SOURCE;

/* Layer node passed from Legend/Survey Manager context menu into Dashboard refresh. */
export interface ContextMenuLayerNode {
  readonly key?: string;
  readonly endPoint?: string;
  readonly category?: string;
  readonly title?: string;
  readonly layerSource?: SurveyLayerSource;
}

export interface LayerRulesForRefresh {
  readonly url?: string;
}

/* Minimal GeoJSON layer surface used by context-menu refresh. */
export interface RefreshableGeoJsonLayer {
  readonly id: string;
  geometryType?: string;
  renderer?: unknown;
  featureReduction?: unknown;
  load: () => Promise<void>;
}
